function NewProductCategories(props) {
    return <>
        {props.models.map((el, index) => {

        })}
    </>
}

export default NewProductCategories;